import React, { useRef } from 'react';
import Icon from 'components/AppIcon';
import CaptchaField from 'components/ui/CaptchaField';
import { notify } from 'shared/utils/notify';
import { Form, Flex, Button, Input, Checkbox } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const LoginForm = ({ onSubmit, isLoading }) => {
  const captchaRef = useRef(null);

  const handleFinish = (values) => {
    const captcha = captchaRef.current?.validate();
    if (!captcha?.valid) {
      if (captcha?.isBot) {
        // honeypot сработал — молча игнорируем
        return;
      }
      notify.error('Неверный код проверки. Попробуйте ещё раз.');
      return;
    }

    onSubmit({
      email: values.email,
      password: values.password,
      rememberMe: !!values.remember
    });
  };

  return (
    <Form
      onFinish={handleFinish}
      onFinishFailed={() => notify.error('Пожалуйста, заполните все обязательные поля')}
      className="space-y-6"
    >
      {/* Email Field */}
      <Form.Item
        name="email"
        layout="vertical"
        label="Email адрес"
        className="text-sm font-medium"
        rules={[
          { required: true, message: 'Пожалуйста, введите email' },
          { pattern: EMAIL_PATTERN, message: 'Введите корректный email адрес' }
        ]}
      >
        <Input
          size="large"
          placeholder="example@authhub.ru"
          disabled={isLoading}
          prefix={<Icon name="Mail" size={16} className="text-secondary-400" />}
        />
      </Form.Item>

      {/* Password Field */}
      <Form.Item
        name="password"
        layout="vertical"
        label="Пароль"
        className="text-sm font-medium"
        rules={[
          { required: true, message: 'Пожалуйста, введите пароль' },
          { min: 6, message: 'Пароль должен содержать минимум 6 символов' }
        ]}
      >
        <Input.Password
          size="large"
          placeholder="Введите пароль"
          disabled={isLoading}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
      </Form.Item>

      {/* Remember Me */}
      <Form.Item className="text-sm font-medium" size="large" name="remember" valuePropName="checked" label={null}>
        <Checkbox disabled={isLoading}>Запомнить меня</Checkbox>
      </Form.Item>

      {/* Captcha */}
      <CaptchaField ref={captchaRef} />

      {/* Submit button */}
      <Flex vertical gap={12}>
        <Button
          type="primary"
          htmlType="submit"
          disabled={isLoading}
          icon={<Icon name="LogIn" size={18} className="mr-1" />}
          className={`
            flex-1 flex items-center justify-center px-4 py-3 
            ${isLoading
              ? 'bg-secondary-200 text-secondary-500 cursor-not-allowed' : 'bg-primary text-white hover:bg-primary-700 active:bg-primary-800'
            }
          `}
        >
          {isLoading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent mr-3"></div>
              Вход в систему...
            </>
          ) : (
            <>
              Войти
            </>
          )}
        </Button>
      </Flex>
    </Form>
  );
};

export default LoginForm;